"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const useAddNewReviewees_1 = require("hooks/useAddNewReviewees/useAddNewReviewees");
const HelperUtils_1 = require("utils/HelperUtils");
const TextArea_1 = __importDefault(require("components/shared/TextArea"));
const ToggledCardAccordion_1 = __importDefault(require("components/shared/ToggledCardAccordion"));
const SettingEmailNotificationStakeholders = () => {
    const { emailStakeholders, isToggleNotificationStakeholdersOn, toggleNotificationStakeholders, handleChangeState, checkIsEmailValid } = (0, useAddNewReviewees_1.useAddNewReviewees)((state) => ({
        emailStakeholders: state.payloadBody.emailStakeholders,
        isToggleNotificationStakeholdersOn: state.isToggleNotificationStakeholdersOn,
        toggleNotificationStakeholders: state.toggleNotificationStakeholders,
        handleChangeState: state.handleChangeState,
        checkIsEmailValid: state.checkIsEmailValid
    }), shallow_1.shallow);
    const isEmailValid = checkIsEmailValid();
    const onChangeNotificationStakeholders = (e) => {
        handleChangeState((draft) => {
            draft.payloadBody.emailStakeholders = e.target.value;
        });
    };
    return (react_1.default.createElement(ToggledCardAccordion_1.default, { title: "Email notification to other stakeholders", subTitle: "The stakeholders will receive email notification if this toggle is being enabled", customClass: "w-[720px]", isOpen: isToggleNotificationStakeholdersOn, toggleCallback: toggleNotificationStakeholders },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: "typography-h100 text-n-800 mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Input Stakeholder’s Email')),
            react_1.default.createElement(TextArea_1.default, { className: "px-[16px] py-[4px]", typographyClass: "text-n-900", height: 96, isTransparent: false, textPlaceholder: "Multiple emails should be separated by (,) e.g. alicia@happy5.co, dinesh@happy5.co, ...", onHandleChange: onChangeNotificationStakeholders, value: emailStakeholders, isError: !isEmailValid, errorMessage: "Please enter valid e-mail address" }))));
};
exports.default = SettingEmailNotificationStakeholders;
